import script from "./Table_Unidentified.vue?vue&type=script&setup=true&lang=js"
export * from "./Table_Unidentified.vue?vue&type=script&setup=true&lang=js"

import "./Table_Unidentified.vue?vue&type=style&index=0&id=61b4c0c3&lang=css"

const __exports__ = script;

export default __exports__